import { render, staticRenderFns } from "./OrderInfoGeneral.vue?vue&type=template&id=5f8a2617&"
import script from "./OrderInfoGeneral.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports